export type SurgicalPlanAliasPayload = Record<string, any>;

export const coalesceSurgicalPlanAliases = (payload: SurgicalPlanAliasPayload) => {
  const conservativePlan =
    payload.conservativePlan ||
    payload.conservativeTreatment ||
    payload.conservativeManagement ||
    {};

  const surgicalOption =
    payload.surgicalOption ||
    payload.surgicalManagement ||
    payload.surgicalDetails ||
    {};

  const surgicalTechniques =
    payload.surgicalTechniques ||
    payload.techniques ||
    payload.suggestedTechniques ||
    payload.techniqueSuggestions ||
    payload.surgicalOptions ||
    [];

  const differentialDiagnoses =
    payload.differentialDiagnoses ||
    payload.differentialDiagnosis ||
    payload.differentials ||
    payload.associatedInjuries ||
    payload.associatedLesions ||
    payload.differentialAndAssociatedInjuries ||
    [];

  const scientificReferences =
    payload.scientificReferences ||
    payload.scientificEvidence ||
    payload.evidence ||
    payload.references ||
    payload.citations ||
    payload.bibliography ||
    [];

  const postoperativeCare =
    payload.postoperativeCare ||
    payload.postOperativeCare ||
    payload.postoperativeProtocol ||
    payload.rehabProtocol ||
    payload.rehabilitation ||
    payload.recoveryPlan ||
    [];

  const planB =
    payload.planB ||
    payload.contingencyPlan ||
    payload.intraoperativeContingencies ||
    payload.fallbackPlan ||
    payload.rescueStrategy ||
    payload.alternativePlan ||
    "";

  const diagnosis =
    payload.diagnosis ||
    payload.mainDiagnosis ||
    payload.primaryDiagnosis ||
    payload.diagnostico ||
    payload.diagnosticSummary ||
    "";

  const anatomicalLocation =
    payload.anatomicalLocation ||
    payload.location ||
    payload.localization ||
    payload.localizacaoAnatomica ||
    payload.localizacao ||
    payload.anatomicLocation ||
    "";

  const materials =
    payload.materials ||
    payload.materialList ||
    payload.implants ||
    payload.materialsAndImplants ||
    [];

  const classificationCode =
    payload.classificationCode ||
    payload.classificationText ||
    payload.classification?.code ||
    "";

  const classificationLabel =
    payload.classificationLabel ||
    payload.classificationDescription ||
    payload.classification?.label ||
    "";

  return {
    ...payload,
    diagnosis,
    mainDiagnosis: payload.mainDiagnosis || diagnosis,
    primaryDiagnosis: payload.primaryDiagnosis || diagnosis,
    diagnostico: payload.diagnostico || diagnosis,
    anatomicalLocation,
    location: payload.location || anatomicalLocation,
    localization: payload.localization || anatomicalLocation,
    localizacaoAnatomica: payload.localizacaoAnatomica || anatomicalLocation,
    localizacao: payload.localizacao || anatomicalLocation,
    conservativePlan,
    conservativeTreatment: payload.conservativeTreatment || conservativePlan,
    conservativeManagement: payload.conservativeManagement || conservativePlan,
    surgicalOption,
    surgicalManagement: payload.surgicalManagement || surgicalOption,
    surgicalTechniques,
    techniques: payload.techniques || surgicalTechniques,
    suggestedTechniques: payload.suggestedTechniques || surgicalTechniques,
    techniqueSuggestions: payload.techniqueSuggestions || surgicalTechniques,
    surgicalOptions: payload.surgicalOptions || surgicalTechniques,
    materials,
    materialList: payload.materialList || materials,
    implants: payload.implants || materials,
    materialsAndImplants: payload.materialsAndImplants || materials,
    classificationCode,
    classificationLabel,
    differentialDiagnoses,
    planB,
    postoperativeCare,
    scientificReferences,
    alternativePlan: payload.alternativePlan || planB,
    contingencyPlan: payload.contingencyPlan || planB,
  };
};
